<template>
  <div class="block grow ms-auto lg:shrink me-4 lg:me-0">
    <ul
      class="navbar-nav flex gap-x-3 items-center justify-end lg:justify-center"
    >
      <slot></slot>
    </ul>
  </div>
</template>
